export enum DateRangeClasses {
  Wrapper = 'date-range',
  NextPrevButton = 'date-range--nextPrevButton',
  InRange = 'date-range--inRange',
  Edge = 'date-range--edge',
  DayNumber = 'date-range--dayNumber',
  DayPassive = 'date-range--dayPassive',
  MonthAndYearWrapper = 'date-range--monthAndYearWrapper',
}
